import {Link} from 'react-router-dom';

export default function NotFoundPage() {
    return (
        <div className="settle-in flex flex-col gap-4 pt-16">
            <h1 className="title m-0">Nothing growing here</h1>
            <p className="m-0 text-ink-2">That page doesn&rsquo;t exist, or it&rsquo;s a bed we haven&rsquo;t dug yet.</p>
            <Link to="/" className="btn btn-primary">
                Back to the start
            </Link>
        </div>
    );
}
